import { render, staticRenderFns } from "./DiagramViewer.vue?vue&type=template&id=45a74a32"
import script from "./DiagramViewer.ts?vue&type=script&lang=ts&external"
export * from "./DiagramViewer.ts?vue&type=script&lang=ts&external"
import style0 from "./DiagramViewer.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports